<mat-card class="viewerholder">
  <div class="docheader">
    <!-- <div class="name"></div> -->
    <!-- <div class="name">Commision Agreements</div> -->
    <div class="name">{{ documentName }}</div>
    <div class="right_pannel">
      <div class="head">
        <!-- <button mat-icon-button color="primary">
          <mat-icon>cloud_download</mat-icon>
        </button>
        <button mat-icon-button color="primary">
          <mat-icon>share</mat-icon>
        </button> -->
        <button mat-icon-button matTooltip="Download" (click)="DownloadFile()"
          matTooltipClass="tooltip" color="primary">
          <mat-icon>cloud_download</mat-icon>
        </button>
        <button mat-icon-button class="closePreview" color="primary" (click)="CloseDocumentViewer(CloseViewDocument)" (click)="tabs.selectedIndex=0">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="tophead">
    <button mat-flat-button class="name" (click)="opendocdetail()">
      <mat-icon color="primary">menu</mat-icon> Detail
    </button>
  </div>

  <div class="docdetail">
    <div class="left_pannel" [ngClass]="{ open: showDetail }">

      <mat-tab-group #tabs (selectedTabChange)="onTabClick($event)">
        
        <mat-tab label="DETAIL"> 

          <form [formGroup]="myFormGroup">
            <div class="info meta">
              <p><span>Doc Name</span>{{ documentName }}</p>
              <p><span>File Type</span>{{ documentType }}</p>
              <p><span>Size</span>{{ fileSize }}</p>
              <p *ngIf="createdOn">
                <span>Upload Date</span>{{ createdOn+'Z' | date: "MM/dd/yyyy" }}
              </p>
              <p *ngIf="createdOn">
                <span>Created Date</span>{{ createdOn+'Z' | date: "MM/dd/yyyy" }}
              </p>
              <p *ngIf="documentdetails?.uploadedByFirstName && documentdetails?.uploadedByLastName && !documentdetails?.externalUploadedBy">
                <span>Uploaded By</span>{{ documentdetails.uploadedByFirstName}} {{documentdetails.uploadedByLastName}}
              </p>
              <p *ngIf="documentdetails?.uploadedByFirstName && !documentdetails?.uploadedByLastName && !documentdetails?.externalUploadedBy">
                <span>Uploaded By</span>{{ documentdetails.uploadedByFirstName}}
              </p>
              <p *ngIf="documentdetails?.externalUploadedBy">
                <span>Uploaded By</span>{{ documentdetails.externalUploadedBy}}
              </p>
            </div>
            <div class="history">
              <div class="title">
                <div class="head">
                  <h3>Description</h3>
                </div>
              </div>
              <mat-form-field class="example-full-width">                
                <!-- <mat-label>Description</mat-label> -->
                <textarea matInput [(ngModel)]="documentdetails.description"  formControlName="description"></textarea>
              </mat-form-field>
            </div>
    
            <div class="history">
              <div class="title">
                <div class="head">
                  <h3>Add Tag</h3>
                </div>
              </div>
    
              <mat-form-field class="example-chip-list">
                <mat-chip-list #chipList aria-label="Tag selection">
                  <mat-chip
                    *ngFor="let tag of tags"
                    [selectable]="selectable"
                    [removable]="removable"
                    (removed)="remove(tag)">
                    {{ tag }}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip>
                  <input
                  
                    #tagInput
                    [formControl]="tagCtrl"
                    [matAutocomplete]="auto"
                    [matChipInputFor]="chipList"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="add($event)"
                  />
                </mat-chip-list>
                <mat-autocomplete
                  #auto="matAutocomplete"
                  (optionSelected)="selected($event)">
                  <mat-option *ngFor="let tag of filteredTags | async" [value]="tag">
                    {{ tag }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </form>
    
          <div class="actionBtn">
            <button mat-flat-button class="cancel" (click)="CloseDocumentViewer(CloseViewDocument)">Cancel</button>
            <button
              mat-flat-button color="primary" type="submit"
              [disabled]="myFormGroup.invalid || !myFormGroup.dirty"
              (click)="UpdateDocumentDetails(myFormGroup.value)">
              Save
              <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
              </mat-spinner></mat-icon>
            </button>
          </div>

        </mat-tab>

        <mat-tab label="ACTIVITY">
          <div class="touches_holder">
            <div class="title">
              <div class="head">
                <h3>Add Activity</h3>             
              </div>
              <!-- <button mat-icon-button color="primary"  (click)="addTouch(touch)" [ngClass]="{ active: addNote }">
                <mat-icon>add</mat-icon>
              </button> -->
  
              <button mat-icon-button color="primary"  (click)="addTouch()" [ngClass]="{ active: addNote }">
                <mat-icon>add</mat-icon>
              </button>
  
            </div>
            <mat-card class="touches" *ngFor="let touch of AllCoreTouchesList">


              <app-touches-list [touch]="touch"  
            (editTouchEmmitter)="editTouch($event)"
            (deleteTouchEmmitter)="deleteTouch($event)"        
            ></app-touches-list>

            </mat-card>
          </div>  
        </mat-tab>
        <mat-tab label="AI DATA">
          <div class="info meta aiTab"  >
            <p *ngFor="let docData of documentData;let i = index" ><span>{{docData.Key}}</span>{{docData.Value}}</p>
            <div *ngIf="documentData==null">
              <p class="notFound"> No Record Found, may be this document not processed with AI Service.</p>
            </div>
          </div>
          
        </mat-tab>
      </mat-tab-group>

      
    </div>

    <div class="viewer">
      <ngx-doc-viewer
        *ngIf="
          documentType == 'doc' ||
          documentType == 'txt' ||
          documentType == 'docx' ||
          documentType == 'ppt' ||
          documentType == 'pptx' ||
          documentType == 'xlsx' ||
          documentType == 'csv' ||
          documentType == 'xls'"
        [url]="documentpath"
        viewer="google"
        width="100%"
        height="100%"
      ></ngx-doc-viewer>
      <ngx-doc-viewer
        *ngIf="
          documentType == 'pdf'"
        [url]="documentpath"
        viewer="url"
        width="100%"
        height="100%"
      ></ngx-doc-viewer>

      <div class="imgPreviewerDoc"
        *ngIf="documentType == 'jpeg' ||
        documentType == 'jpg' ||
        documentType == 'png' ||
        documentType == 'gif' ||
        documentType == 'gif'"
        > 
        <img src="{{documentpath}}" >
  
        </div>
        <div class="imgPreviewerDoc"
        *ngIf="documentType == 'heic'"> 
        <img src="{{selectedImagetoShow}}" > 
        </div>


    </div>

    <div
      class="lefoverlay"
      (click)="opendocdetail()"
      [ngClass]="{ open: showDetail }"
    ></div>
  </div>
</mat-card>

<div class="overlay" (click)="CloseDocumentViewer(CloseViewDocument)"></div>

<app-loader></app-loader>